export const GET_USER_INFO_REQUEST = "GET_USER_INFO_REQUEST";
export const GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS";
export const GET_USER_INFO_FAILURE = "GET_USER_INFO_FAILURE";
export const getUserInfoRequest = (payload) => ({
    type: GET_USER_INFO_REQUEST,
    payload,
});
export const getUserInfoSuccess = (payload) => ({
    type: GET_USER_INFO_SUCCESS,
    payload,
});
export const getUserInfoFailure = (payload) => ({
    type: GET_USER_INFO_FAILURE,
    payload,
});
